import * as React from 'react';

function SvgClockStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 26.327C8.744 26.327 3.673 21.256 3.673 15S8.744 3.673 15 3.673 26.327 8.744 26.327 15 21.255 26.327 15 26.327zm0-1.5c5.427 0 9.827-4.4 9.827-9.827S20.427 5.173 15 5.173 5.173 9.573 5.173 15s4.4 9.827 9.827 9.827zm4.874-6.014L15.75 14.69V7.096a.75.75 0 00-1.5 0V15c0 .199.079.39.22.53l4.343 4.344a.75.75 0 001.06-1.06z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgClockStroke;
